module.exports = __webpack_public_path__ + "static/media/search-news.77e8a6e6.svg";